// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3x_Bk","list":"BalanceDue_list__FjOav","listRow":"BalanceDue_listRow__2ytx2","total":"BalanceDue_total__2oGyf"};